import React, { useState, useEffect, useContext } from 'react';
import { Table, Button, Drawer, Form, Input, message } from 'antd';
import axios from 'axios';
import { LoginContext } from '../../context/loginContext';

const CCategorias = () => {
  const [categorias, setCategorias] = useState([]);
  const [drawerVisible, setDrawerVisible] = useState(false);
  const [editCategoria, setEditCategoria] = useState(null);
  const [form] = Form.useForm();
  const { user } = useContext(LoginContext);

  const [searchText, setSearchText] = useState('');
  const [searchedColumn, setSearchedColumn] = useState('');

  useEffect(() => {
    fetchCategorias();
  }, []);

  const fetchCategorias = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_URL}/categorias`, {
        headers: {
          Authorization: `Bearer ${user.token}`,
        },
      });
      setCategorias(response.data);
    } catch (error) {
      console.error('Error al obtener categorías:', error);
    }
  };

  const openDrawer = (categoria = null) => {
    setEditCategoria(categoria);
    setDrawerVisible(true);
    if (categoria) {
      form.setFieldsValue(categoria);
    } else {
      form.resetFields();
    }
  };

  const closeDrawer = () => {
    setDrawerVisible(false);
  };

  const handleSaveCategoria = async (values) => {
    try {
      const headers = {
        Authorization: `Bearer ${user.token}`,
      };

      if (editCategoria) {
        await axios.put(`${process.env.REACT_APP_API_URL}/categorias/${editCategoria._id}`, values, { headers });
        message.success('Categoría actualizada correctamente');
      } else {
        await axios.post(`${process.env.REACT_APP_API_URL}/categorias`, values, { headers });
        message.success('Categoría creada correctamente');
      }

      fetchCategorias();
      closeDrawer();
    } catch (error) {
      message.error('Error al guardar categoría');
      console.error('Error al guardar categoría:', error);
    }
  };

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };

  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText('');
  };

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          placeholder={`Buscar ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ marginBottom: 8, display: 'block' }}
        />
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <Button type="primary" onClick={() => handleSearch(selectedKeys, confirm, dataIndex)} size="small">
            Buscar
          </Button>
          <Button onClick={() => handleReset(clearFilters)} size="small">
            Resetear
          </Button>
        </div>
      </div>
    ),
    filterIcon: (filtered) => <span style={{ color: filtered ? '#1890ff' : undefined }}>🔍</span>,
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex].toString().toLowerCase().includes(value.toLowerCase())
        : '',
    render: (text) =>
      searchedColumn === dataIndex ? (
        <span style={{ backgroundColor: '#ffc069', padding: '0 5px' }}>{text}</span>
      ) : (
        text
      ),
  });

  const columns = [
    {
      title: 'Nombre de Categoría',
      dataIndex: 'nombre',
      key: 'nombre',
      ...getColumnSearchProps('nombre'),
    },
    {
      title: 'Acciones',
      key: 'acciones',
      render: (text, record) => (
        <Button type="link" onClick={() => openDrawer(record)}>
          Editar
        </Button>
      ),
    },
  ];

  return (
    <>
      <Button type="primary" onClick={() => openDrawer()} style={{ marginBottom: 16 }}>
        Agregar Categoría
      </Button>

      <Table columns={columns} dataSource={categorias} rowKey="_id" />

      <Drawer
        title={editCategoria ? 'Editar Categoría' : 'Agregar Categoría'}
        width={400}
        onClose={closeDrawer}
        visible={drawerVisible}
        bodyStyle={{ paddingBottom: 80 }}
      >
        <Form form={form} layout="vertical" onFinish={handleSaveCategoria}>
          <Form.Item
            name="nombre"
            label="Nombre de Categoría"
            rules={[{ required: true, message: 'Por favor ingresa un nombre de categoría' }]}
          >
            <Input placeholder="Nombre de Categoría" />
          </Form.Item>

          <Form.Item>
            <Button type="primary" htmlType="submit" block>
              {editCategoria ? 'Actualizar Categoría' : 'Crear Categoría'}
            </Button>
          </Form.Item>
        </Form>
      </Drawer>
    </>
  );
};

export default CCategorias;